import React, { Component } from 'react'
import { QRCode } from 'react-qrcode-logo'

export default class ShareQrCode extends Component {
    state = {
        recently: [
            { img: '/images/p1.png', name: 'Parna Azizi' },
            { img: '/images/p2.png', name: 'Pedram Pezhman' },
            { img: '/images/p3.png', name: 'Reza Salek' },
            { img: '/images/p4.png', name: 'Morshedy' },
            { img: '/images/p5.png', name: 'Hossein Mohseni' },
            { img: '/images/p6.png', name: 'Hossein Mohseni' },
            { img: '/images/p1.png', name: 'Parna Azizi' },
            { img: '/images/p2.png', name: 'Pedram Pezhman' },
            { img: '/images/p3.png', name: 'Reza Salek' },
            { img: '/images/p4.png', name: 'Morshedy' },
            { img: '/images/p5.png', name: 'Hossein Mohseni' },
            { img: '/images/p6.png', name: 'Hossein Mohseni' },
        ],

        tools: [
            { name: 'Copy', icon: '/assets/icons/developer/copy.svg' },
            { name: 'Messenger', icon: '/assets/icons/portals/folder2.svg' },
            { name: 'Email', icon: '/assets/icons/portals/mailtest.png' },
            { name: 'Task', icon: '/assets/icons/portals/desktest.svg' },
        ]
    }
    render() {
        return (
            <div className='w-100'>
                <div className='px-4 pt-4' style={{}}>
                    <div className='flexcb w-100 pb-2' style={{ borderBottom: '1px solid #eee', }}>
                        <div className='' style={{ width: 'calc(100% - 100px)' }}>
                            <div className='flexc pb-4'>
                                <img className='shadow-2 br-10' width={100} src={this.props.img} />
                                <div className='mld-3'>
                                    <p className='font-size-16 weight-500 main-c3'>{this.props.name}</p>
                                    <p className='font-size-14 main-c7'>{this.props.des}</p>
                                    <button className='flexc gray-boder-btn br-5 pld-4 prd-3 py-1 mt-2'>
                                        <p>Option</p>
                                        <img width={22} src='/assets/icons/arrow-right-gray.svg' />
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div className=''>
                            <QRCode onClick={() => this.props.visitApplet()} quietZone={0} ecLevel={'H'} size="100" logoPadding={0} logoImage={'/assets/icons/booking/qrcode.png'} removeQrCodeBehindLogo={true} logoWidth={30} qrStyle={'dots'} eyeRadius={[[10, 10, 0, 10], [10, 10, 10, 0], [10, 0, 10, 10],]} eyeColor={'#333'} bgColor={this.props.bgColor} enableCORS={true} />
                        </div>
                    </div>
                </div>
                <div className='px-4'>

                    <div className='d-flex flexcb cred-box-developer py-2 px-3 mt-4'>
                        <p className='mrd-4'>{this.props.initData?.accessKey?.credential}</p>
                        <button>
                            <img src='/images/icons/Copy.svg' />
                        </button>
                    </div>


                    <div className='mt-4 ' style={{ borderBottom: '1px solid #eee' }}>
                        <div className='d-flex sc-gray pb-2' style={{ alignItems: 'flex-start', overflowX: 'auto', }}>
                            {this.state.recently.map((prop, index) => {
                                return (
                                    <button className='mrd-8' style={{ maxWidth: '65px', minWidth: '65px' }}>
                                        <img width={60} className='br-50' src={prop.img} />
                                        <p className='font-size-10 main-c7'>{prop.name}</p>
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                    <div className='flexc w-100 pt-3 pb-2 ' style={{ borderTop: '1px solid #eee' }}>
                        {this.state.tools.map((prop, index) => {
                            return (
                                <button className='flexcc flex-column text-center  px-3 py-2 br-30'>
                                    <img width={40} className='' src={prop.icon} />
                                    <p>{prop.name}</p>
                                </button>
                            )
                        })}
                    </div>

                </div>
            </div>
        )
    }
}
